import { render, staticRenderFns } from "./CurrencyTransaction.vue?vue&type=template&id=de628554&scoped=true&"
import script from "./CurrencyTransaction.vue?vue&type=script&lang=js&"
export * from "./CurrencyTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de628554",
  null
  
)

export default component.exports